<script>
import { Line, mixins } from 'vue-chartjs'
import numeral from 'numeral'
import moment from 'moment'
export default {
  extends: Line,
  props: {
    axeTypeY: {
      type: String,
      required: false,
      default: 'number'
    },
    numberLabel: {
      type: String,
      required: false,
      default: ''
    },
    numberRounded: {
      type: Boolean,
      required: false,
      default: false
    },
    dateFormat: {
      type: String,
      required: false,
      default: 'MMM YYYY'
    },
    dateFormatAxe: {
      type: String,
      required: false,
      default: 'MMM YY'
    },
    axeTypeX: {
      type: String,
      required: false,
      default: 'date'
    },
    colors: {
      type: Array,
      required: false,
      default () {
        return ['#3F51B5']
      }
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'rgba(63, 81, 181, 0.1)'
    },
    customLabels: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    showAxeX: {
      type: Boolean,
      required: false,
      default: true
    },
    showAxeY: {
      type: Boolean,
      required: false,
      default: false
    },
    showGridLinesAxeY: {
      type: Boolean,
      required: false,
      default: false
    },
    showDrawBorderGridLinesAxeY: {
      type: Boolean,
      required: false,
      default: false
    },
    showPoint: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [
    mixins.reactiveProp
  ],
  data () {
    return {
      // colors: ['#3F51B5'],
      colorsHover: ['#004FE2']
    }
  },
  mounted () {
    this.addPlugin({
      id: 'vertical-line',
      afterDraw: function (chart) {
        if (chart.tooltip._active && chart.tooltip._active.length) {
          let activePoint = chart.tooltip._active[0]
          let ctx = chart.ctx
          let x = activePoint.tooltipPosition().x
          let topY = chart.legend.bottom
          let bottomY = chart.chartArea.bottom

          // draw vertical line
          ctx.save()
          ctx.beginPath()
          ctx.moveTo(x, topY)
          ctx.lineTo(x, bottomY)
          ctx.lineWidth = 1
          ctx.strokeStyle = '#D8E0EA'
          ctx.stroke()
          ctx.restore()
        }
      }
    })
    this.drawChart()
  },
  watch: {
    chartData () {
      this.drawChart()
    }
  },
  computed: {
    options () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: 4
        },
        hover: {
          mode: 'index',
          intersect: true
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          enabled: false,
          custom: this.customTooltips,
          displayColors: false,
          backgroundColor: '#FFFFFF',
          titleFontColor: '#525F7F',
          titleFontSize: 12,
          titleMarginBottom: 10,
          bodyFontStyle: 'bold',
          bodyFontColor: 'red',
          borderColor: '#D8E0EA',
          borderWidth: 1,
          xPadding: 20,
          yPadding: 10,
          callbacks: {
            title: (items, data) => {
              return moment(items[0].xLabel.split('T')[0]).format(this.dateFormat)
            },
            label: (item, data) => {
              let label = data.datasets[item.datasetIndex].label
              let value = item.yLabel
              if (this.axeTypeY === 'number') {
                numeral.localeData().delimiters.thousands = this.numberRounded ? '.' : ','
                numeral.localeData().delimiters.decimal = this.numberRounded ? ',' : '.'
                value = numeral(value).format(this.numberRounded ? '0,0' : '0,0.00')
              }
              if (this.numberLabel) {
                value = `${value} ${this.numberLabel}`
              }
              return {
                label: label,
                value: value
              }
            }
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              color: '#D8E0EA',
              display: this.showGridLinesAxeY,
              drawBorder: false,
              drawTicks: false,
              zeroLineColor: '#D8E0EA',
              zeroLineWidth: 1
            },
            ticks: {
              display: this.showAxeY,
              fontSize: 12,
              fontColor: '#6B7C93',
              fontFamily: 'Open Sans',
              maxRotation: 0,
              maxTicksLimit: 3
            }
          }],
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false,
              drawTicks: false
            },
            ticks: {
              display: this.showAxeX,
              fontSize: 12,
              fontColor: '#6B7C93',
              fontFamily: 'Open Sans',
              maxRotation: 0,
              maxTicksLimit: 2,
              padding: 10,
              callback: (value) => {
                return moment(value.split('T')[0]).format(this.dateFormatAxe)
              }
            }
          }]
        }
      }
    }
  },
  methods: {
    drawDatasets () {
      this.chartData.datasets.forEach((dataset, i) => {
        this.chartData.datasets[i] = Object.assign({}, this.chartData.datasets[i], {
          backgroundColor: i === 0 ? `${this.backgroundColor}` : 'transparent',
          borderColor: this.colors[i],
          borderWidth: 1.5,
          pointStyle: 'circle',
          pointRadius: 3,
          pointHoverRadius: 3,
          pointBorderWidth: 0,
          pointBackgroundColor: this.colors[i],
          lineTension: 0
        })
      })
    },
    drawChart () {
      this.drawDatasets()
      this.renderChart(this.chartData, this.options)
    },
    customTooltips (tooltip) {
      const foundLabel = this.customLabels.some(label => label === 'Cancelación de suscripciones' || label === 'Contracción del MRR')
      let tooltipEl = document.getElementById(`chartjs-tooltip__${this.chartId}`)
      if (!tooltipEl) {
        tooltipEl = document.createElement('div')
        tooltipEl.id = `chartjs-tooltip__${this.chartId}`
        tooltipEl.innerHTML = '<table></table>'
        this.$refs.canvas.parentNode.appendChild(tooltipEl)
      }
      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0
        return
      }
      if (tooltip.body) {
        const title = tooltip.title || []
        const lines = tooltip.body.map(tooltip => tooltip.lines[0])
        let html = '<thead>'
        title.forEach((title) => {
          html += '<tr>'
          html += `<th class="text-left text--secondary font-weight-medium">${title}</th>`
          if (this.chartData.datasets[0].percent_change) {
            const percent = this.chartData.datasets[0].percent_change[tooltip.dataPoints[0].index]
            let textColor = ''
            if (percent > 0) {
              textColor = foundLabel ? 'red--text text--darken-1' : 'green--text text--darken-1'
            } else if (percent < 0) {
              textColor = foundLabel ? 'green--text text--darken-1' : 'red--text text--darken-1'
            } else {
              textColor = 'text--secondary'
            }
            const percentNumeral = numeral(percent).format('0,0.00')
            html += `<th class="text-right font-weight-medium ${textColor}">${percentNumeral}%</th>`
          }
          html += `</tr>`
        })
        html += '</thead>'
        html += '<tbody>'
        lines.forEach((body, i) => {
          const colors = tooltip.labelColors[i]
          const label = this.customLabels[i] ? this.customLabels[i] : body.label
          html += `
            <tr>
              <td class="text-left">
                <div class="text-truncate" style="max-width:120px;">
                  <span class="chartjs-tooltip-key" style="background:${colors.backgroundColor}; border-color:${colors.borderColor}"></span> ${label}
                </div>
              </td>
              <td class="text-right">${body.value}</td>
            </tr>
          `
        })
        html += '</tbody>'
        tooltipEl.querySelector('table').innerHTML = html
      }
      // display, position, and set styles for font
      tooltipEl.style.opacity = 1
      let idTooltip = document.getElementById(`chartjs-tooltip__${this.chartId}`)

      // default position
      tooltipEl.style.left = `${this.$refs.canvas.offsetLeft + tooltip.caretX - 35}px`
      idTooltip.style.setProperty('--left-pseudo', '25px')

      // offset position
      if (Math.round(tooltip.caretX) + tooltipEl.offsetWidth >= this.$refs.canvas.width / 2) {
        tooltipEl.style.left = `${this.$refs.canvas.offsetLeft + tooltip.caretX - 205}px`
        idTooltip.style.setProperty('--left-pseudo', '195px')
      }

      tooltipEl.style.top = `${tooltip.height * -1 + 25}px`
      tooltipEl.style.fontFamily = tooltip._bodyFontFamily
      tooltipEl.style.fontSize = `${tooltip.bodyFontSize}px`
      tooltipEl.style.fontStyle = tooltip._bodyFontStyle
      tooltipEl.style.backgroundColor = tooltip.backgroundColor
      tooltipEl.style.titleFontColor = tooltip.titleFontColor
      tooltipEl.style.bodyFontColor = tooltip.bodyFontColor
      tooltipEl.style.borderColor = tooltip.borderColor
      tooltipEl.style.borderWidth = tooltip.borderWidth
    }
  }
}
</script>